import { useEffect } from 'react';
import { useMyBatches } from './useLms';
import { useUiStore } from '@/stores/uiStore';

export const ALL_BATCHES = 'all';

export function useCurrentBatch() {
  const { data: batches = [], isLoading } = useMyBatches();
  const currentBatchId = useUiStore((s) => s.currentBatchId);
  const setBatch = useUiStore((s) => s.setCurrentBatchId);

  useEffect(() => {
    if (isLoading || batches.length === 0) return;
    if (currentBatchId === ALL_BATCHES) return; // "All" is always valid
    const valid = currentBatchId && batches.some((b) => b.id === currentBatchId);
    if (!valid) setBatch(batches.length > 1 ? ALL_BATCHES : batches[0].id);
  }, [isLoading, batches, currentBatchId, setBatch]);

  const isAll = currentBatchId === ALL_BATCHES;
  const batch = isAll ? null : (batches.find((b) => b.id === currentBatchId) ?? null);
  return { batchId: isAll ? null : currentBatchId, batch, batches, setBatch, isLoading, isAll };
}
